/**
 * Header chrome: APS account menu + Standalone/Forma demo switcher.
 * Render inside each shell's header row (not fixed) so layout stays in flow.
 */
import { useHashRoute } from "../hooks/useHashRoute";
import { UserMenu } from "./UserMenu";
import { ViewToggle } from "./ViewToggle";

export function TopChrome() {
  const route = useHashRoute();
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        flexShrink: 0,
      }}
    >
      <UserMenu />
      <ViewToggle variant={route === "forma" ? "light" : "dark"} />
    </div>
  );
}
